import { DirectMessage, User } from '../types'

interface MessageBubbleProps {
  message: DirectMessage
  sender: User | undefined
  isOwnMessage: boolean
  showAvatar: boolean
  showTime: boolean
  getRoleColor: (role: string) => string
  getRoleBadge: (role: string) => string
}

export default function MessageBubble({
  message,
  sender,
  isOwnMessage,
  showAvatar,
  showTime,
  getRoleColor,
  getRoleBadge
}: MessageBubbleProps) {

  return (
    <div className={`message-row ${isOwnMessage ? 'own-message' : 'other-message'}`}>
      {/* Left side - Avatar or spacer */}
      <div className="message-avatar-column">
        {showAvatar && !isOwnMessage ? (
          <div className="user-avatar">
            <div className="avatar-fallback">
              {sender?.username ? sender.username.slice(0, 2).toUpperCase() : 'U'}
            </div>
          </div>
        ) : (
          <div className="avatar-spacer"></div>
        )}
      </div>

      {/* Right side - Message content */}
      <div className="message-content-column">
        {/* Username and timestamp header */}
        {showAvatar && !isOwnMessage && (
          <div className="message-header">
            <span 
              className="username"
              style={{ color: getRoleColor(sender?.role || 'member') }}
            >
              {getRoleBadge(sender?.role || 'member')} {sender?.username || 'Unknown User'}
            </span>
            <span className="timestamp">
              {new Date(message.dateSent).toLocaleString('en-US', {
                month: 'numeric',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
              })}
            </span>
          </div>
        )}

        {/* Message bubble */}
        <div className={`message-bubble ${isOwnMessage ? 'own-bubble' : 'other-bubble'}`}>
          <div className="bubble-content">
            {message.content}
          </div>
          
          {/* Message status for own messages */}
          {isOwnMessage && (
            <div className="message-status">
              <span className={`status-check ${message.isRead ? 'read' : 'sent'}`}>
                {message.isRead ? '✓✓' : '✓'}
              </span>
            </div>
          )}
        </div>

        {/* Show time on hover for grouped messages */}
        {!showAvatar && (
          <div className="hover-timestamp">
            {new Date(message.dateSent).toLocaleTimeString('en-US', {
              hour: 'numeric',
              minute: '2-digit',
              hour12: true
            })}
          </div>
        )}
      </div>
    </div>
  )
}